import { HttpStatusCodeEnum } from '../../enums/http-status-code.enum';

import { GatewayRequestType } from './types';

export const WEB_SOCKET_CONNECTION_TRY_COUNT = 5;
export const WEB_SOCKET_MAX_SUCCESS_STATUS = 299;

/** Requests that must not be replayed after a reconnect - they are one-shot or re-issued by the app. */
export const GW_NON_RESTORABLE_MESSAGE_TYPES = new Set<GatewayRequestType>([
  GatewayRequestType.Login,
  GatewayRequestType.Ping,
  GatewayRequestType.NewOrderRequest,
  GatewayRequestType.ModifyOrderRequest,
  GatewayRequestType.CancelOrderRequest,
  GatewayRequestType.GetLatestNewsArticles,
  GatewayRequestType.GetLatestNewsArticlesBySymbols,
]);

/** Subscription requests whose missing response is worth reporting. */
export const LATE_REQUEST_TRACKED_MESSAGE_TYPES = new Set<GatewayRequestType>([
  GatewayRequestType.InstrumentSnapshot,
  GatewayRequestType.MarketDataSummary,
  GatewayRequestType.MarketDataSubscribeTrade,
  GatewayRequestType.MarketDataSubscribeNbbo,
  GatewayRequestType.MarketDataSubscribeSymbolStatus,
]);

export const LATE_REQUEST_THRESHOLD_MS = 5000;
export const LATE_REQUEST_SWEEP_INTERVAL_MS = 5000;
export const LATE_REQUEST_RELOG_INTERVAL_MS = 30000;
/** A response arriving later than this is reported once, with its trace id. */
export const LATE_RESPONSE_THRESHOLD_MS = 3000;
/**
 * Backoff for reconnects caused by the socket dropping on its own. A fixed short delay against a
 * flapping gateway just reconnects in a tight loop.
 */
export const RECOVERY_RECONNECT_DELAY_MS = [ 1000, 2000, 5000, 10000, 20000 ];
export const RECOVERY_RECONNECT_REASONS = new Set([ 'remote_close', 'socket_error' ]);
export const MANUAL_RECONNECT_REASON = 'reconnect';
/** Marks a close the app asked for, so it is not mistaken for the gateway dropping us. */
export const MANUAL_DISCONNECT_REASON = 'manual_disconnect';
export const REMOTE_CLOSE_REASON = 'remote_close';

/** Gateway result codes worth retrying - the request was not refused, the service was busy. */
export const GW_TRANSIENT_RESPONSE_RETRY_LIMIT = 3;
export const GW_TRANSIENT_RESPONSE_RETRYABLE_RESULT_CODES = new Set([
  HttpStatusCodeEnum.RequestTimeout,
  HttpStatusCodeEnum.ServiceUnavailable,
]);
